import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  getReportFormats as onGetReportFormats
} from '../../actions/reportFormatsActions'

const mapStateToProps = state => ({
  reportFormatsDataState: state.reportFormats.dataState,
  reportFormatsData: get(state, ['reportFormats', 'data', 'formats'], []),
  reportFormatsErrors: get(state, ['reportFormats', 'errors'], [])
})

const mapDispatchToProps = {
  onGetReportFormats
}

const withReportFormats = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportFormats }